import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { DcrResults } from '@/core/graphql/generated/types';

import { type DCRState } from './dcr.types';

export const useDcrStore = create<DCRState>()(
	devtools(set => ({
		dcrs: [],
		rowCount: 0,

		dcrFormSearchTerm: '',
		dcrFormFilteredFields: [],

		setDcrs: (dcrResults: DcrResults) =>
			set(() => ({
				dcrs: dcrResults.results,
				rowCount: dcrResults.total
			})),

		setDcrFormSearchTerm: (dcrFormSearchTerm: string) => {
			return set(() => ({
				dcrFormSearchTerm
			}));
		},
		setDcrFormFilteredFields: (
			dcrFormFilteredFields: Record<string, string[]>
		) =>
			set(() => ({
				dcrFormFilteredFields
			}))
	}))
);
